import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicFieldDropdown, BaasicButton } from 'core/components';

function CreateFacilityOrderTemplateModalTemplate({ createFacilityOrderTemplateModalStore , t}) {
    const {
        form,
        subCategoryStore,
        modalParams
    } = createFacilityOrderTemplateModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Add New Template</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicFormControls
                    form={form} 
                    onSubmit={form.onSubmit} 
                    className='btn btn--med btn--primary'
                    disabled={form.submitting || form.validating}
                    label="Create"
                />  
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                    disabled={form.submitting || form.validating}
                />
            </div>
        </section> 
    )
}
 
CreateFacilityOrderTemplateModalTemplate.propTypes = {
    createFacilityOrderTemplateModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(CreateFacilityOrderTemplateModalTemplate);
